import { render, staticRenderFns } from "./CopyTermForm.vue?vue&type=template&id=0315dd47&"
import script from "./CopyTermForm.vue?vue&type=script&lang=js&"
export * from "./CopyTermForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports